import { apiUtil } from 'lifesci-ui'

const { getApiPathPrefix, request } = apiUtil

function path() {
  return `${getApiPathPrefix('VUE_APP_BASE_PATH_CSA_ADMIN')}`
}

export function getResource(data) {
  return request({
    url: `${path()}/resource`,
    method: 'post',
    data: data
  })
}
